import * as React from "react";
import * as cn from "classnames";
import * as styles from "./styles.css";
import { formatAttributions } from "../../../../shared/utils/image";
export var attributionCopy = "Image by";
var HeroAttribution = function (_a) {
    var _b = _a.attributions, attributions = _b === void 0 ? [] : _b, className = _a.className;
    var formattedAttribution = formatAttributions(attributions);
    var attributionDisplay = formattedAttribution ? attributionCopy + " " + formattedAttribution : "";
    return (React.createElement("p", { className: cn(styles.heroAttribution, className) }, attributionDisplay));
};
export default HeroAttribution;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/hero/heroAttribution.tsx
// module id = opmm
// module chunks = 2